import React from 'react';
import { StyleProp, TextStyle, View } from 'react-native';

import { Txt } from './Txt';
import { theme } from 'lib/theme';
import { Icon, ICONS } from './Icon';

type PillProps = {
  label: string;
  withIcon: boolean;
  icon?: ICONS;
  iconColor?: string;
  iconSize?: number;
  style?: React.ComponentProps<typeof View>['style'];
  textSize?: React.ComponentProps<typeof Txt>['size'];
  textStyle?: StyleProp<TextStyle>;
  textWeight?: React.ComponentProps<typeof Txt>['weight'];
  transparent?: boolean;
};

export const Pill: React.FC<PillProps> = ({
  label,
  withIcon = false,
  icon = ICONS.CircleSolid,
  iconColor,
  iconSize = 12,
  style,
  textSize,
  textStyle,
  textWeight,
  transparent = false,
}) => (
  <View
    style={[
      transparent
        ? {
            borderRadius: 99,
            alignItems: 'center',
            flexDirection: 'row',
            gap: theme.paddingHorizontalHalf,
            minHeight: 24,
            maxWidth: '100%',
          }
        : {
            backgroundColor: theme.colors.black3,
            borderRadius: 99,
            alignItems: 'center',
            flexDirection: 'row',
            paddingVertical: theme.padding / 2,
            paddingRight: theme.padding,
            paddingLeft: withIcon ? theme.padding / 2 : theme.padding,
            gap: theme.paddingHorizontalHalf,
            minHeight: 24,
            maxWidth: '100%',
          },
      style,
    ]}
  >
    {withIcon && (
      <Icon
        source={icon}
        color={iconColor || theme.colors.red}
        size={iconSize}
        style={transparent ? { marginTop: 2 } : null}
      />
    )}
    <Txt
      size={textSize ?? (transparent ? 'normal' : 'xsmall')}
      weight={textWeight}
      numberOfLines={1}
      style={textStyle}
    >
      {label}
    </Txt>
  </View>
);
